import React, { useState } from "react";
import "./organization.css";

import {
  Search,
  Building2,
  Plus,
  UserRound
} from "lucide-react";

export default function OrganizationDashboard() {
  const [selected, setSelected] = useState(2); // Default to InTrust BFSI Limited

  const organizations = [
    {
      id: 1,
      name: "InTrust Global Corp",
      dept: "5 Departments",
      users: "150 Users",
      active: true
    },
    {
      id: 2,
      name: "InTrust BFSI Limited",
      dept: "8 Departments",
      users: "320 Users",
      active: true
    },
    {
      id: 3,
      name: "InTrust Government",
      dept: "6 Departments",
      users: "210 Users",
      active: true
    },
    {
      id: 4,
      name: "InTrust Healthcare",
      dept: "4 Departments",
      users: "120 Users",
      active: true
    },
    {
      id: 5,
      name: "InTrust Private Limited",
      dept: "3 Departments",
      users: "45 Users",
      active: false
    }
  ];

  const departments = [
    ["Administration", "32 Users"],
    ["Human Resources", "20 Users"],
    ["Finance", "45 Users"],
    ["IT & Security", "50 Users"],
    ["Compliance & Legal", "30 Users"],
    ["Operations", "67 Users"],
    ["Risk Management", "29 Users"],
    ["Audit", "25 Users"]
  ];

  const selectedOrg = organizations.find(org => org.id === selected);

  return (
    <div style={{ background: "#f8fafc", minHeight: "100vh", padding: "0" }}>
      <div className="org-page">

        {/* LEFT PANEL */}
        <div className="dept-col">
          <div className="dept-top-bar"></div>
          <div className="org-list card">
            <h4>Organizations (5)</h4>
            <div className="search">
              <Search size={14} />
              <input placeholder="Search organization..." />
            </div>
            {organizations.map(org => (
              <div
                className={selected === org.id ? "org-item selected" : "org-item"}
                onClick={() => setSelected(org.id)}
                key={org.id}
              >
                <div className="org-icon"><Building2 size={14} /></div>
                <div>
                  <b>{org.name}</b>
                  <p>{org.dept} • {org.users}</p>
                </div>
                <span className={org.active ? "active" : "inactive"}>
                  {org.active ? "Active" : "Inactive"}
                </span>
              </div>
            ))}
            <p className="footer">Showing 1 to 5 of 5 organizations</p>
          </div>
        </div>

        {/* CENTER PANEL */}
        <div className="dept-col">
          <div className="dept-top-bar"></div>
          <div className="org-details card">
            <div className="title-row">
              <h4>Organization Details</h4>
              <h2>
                {selectedOrg?.name}
                <span className="active">{selectedOrg?.active ? "Active" : "Inactive"}</span>
              </h2>
              <p>ID: org_87fd2e...</p>
            </div>
            <div className="tabs">
              <span className="active-tab">Overview</span>
              <span>Departments</span>
              <span>Users</span>
              <span>Compliance Domains</span>
              <span>Settings</span>
            </div>
            <div className="stats">
              <div><p>Total Users</p><h3>320</h3></div>
              <div><p>Departments</p><h3>8</h3></div>
              <div><p>Active Devices</p><h3>287</h3></div>
              <div><p>Documents Signed</p><h3>12,456</h3></div>
            </div>
            <div className="box">
              <h4>Compliance Domains</h4>
              <div className="tags">
                <span>eIDAS</span>
                <span>GDPR</span>
                <span>ISO 27001</span>
                <span>DPOP India</span>
              </div>
            </div>
            <div className="split">
              <div className="box"><p>Subscription Plan</p><h3>Enterprise</h3></div>
              <div className="box"><p>Valid Until</p><h3>May 15, 2025</h3></div>
            </div>
            <div className="box">
              <p>Storage Used</p>
              <h3 style={{ fontSize: "12px", marginTop: "4px" }}>2.45 TB / 10 TB (24.5%)</h3>
              <div className="progress"><div></div></div>
            </div>
          </div>
        </div>

        {/* RIGHT PANEL */}
        <div className="dept-col">
          <div className="dept-top-bar">
            <button className="new-org-btn"><Plus size={13} /> New Organization</button>
          </div>
          <div className="dept card">
            <div className="dept-header">
              <h4>Departments (8)</h4>
              <button><Plus size={13} /> Add Department</button>
            </div>
            {departments.map((d) => (
              <div className="dept-item" key={d[0]}>
                <UserRound size={14} />
                <div>
                  <b>{d[0]}</b>
                  <p>{d[1]}</p>
                </div>
              </div>
            ))}
            <a href="#">View all departments →</a>
          </div>
        </div>

      </div>
    </div>
  );
}